import RedirectRoute from './RedirectRouteContainer';

export default RedirectRoute;
